export default __webpack_public_path__ + "media/images/images/elements/08-f165437adc41ef76a06bb58fa0651134.png";